/* CROOKED PDP behaviors — gallery swap, size radios, NEAR/FAR sad paths, rail adds.
   Depends on crk-cart-drawer.js (window.CRKDrawer) — loaded first, both deferred. */
(function(){
  "use strict";
  var $=function(s){return document.querySelector(s)};
  var el=$("[data-crk-product]");
  if(!el)return;
  var PRODUCT=JSON.parse(el.textContent);
  /* The gallery is pure scroll behavior and must NOT be gated on the cart
     drawer — if CRKDrawer ever fails to load, swiping still has to work. Buy-path
     wiring below re-checks window.CRKDrawer at its own use sites. */

  /* ---- swipe gallery ----
     A native horizontal scroll-snap track replaced the old JS src-swap plus its
     warm/rung prefetch layer (~34 lines, deleted). That machinery existed only to
     stop a JS swap feeling slow; with a track there is no swap at all — every
     frame is in the DOM and the browser decodes ahead along the scroll axis.
     Less code, better feel, real momentum. */
  var viewport=$("#galViewport");
  var thumbBtns=[].slice.call(document.querySelectorAll("#galThumbs button"));
  if(viewport){
    var slides=[].slice.call(viewport.querySelectorAll(".crk-gal__slide"));
    var active=0;
    function markActive(i){
      if(i===active||i<0||i>=slides.length)return;
      active=i;
      thumbBtns.forEach(function(b,bi){
        var on=bi===i;
        b.classList.toggle("on",on);
        if(on)b.setAttribute("aria-current","true");else b.removeAttribute("aria-current");
      });
    }
    function goTo(i,smooth){
      /* index * clientWidth, NOT slide.offsetLeft: offsetLeft is measured from
         the offsetParent, which is not the viewport here, so it overshoots by
         the page inset. Slides are exactly 100% wide, so arithmetic is exact. */
      viewport.scrollTo({left:i*viewport.clientWidth,behavior:smooth===false?"auto":"smooth"});
    }
    var ticking=false;
    viewport.addEventListener("scroll",function(){
      if(ticking)return;ticking=true;
      requestAnimationFrame(function(){
        ticking=false;
        var w=viewport.clientWidth;
        if(w)markActive(Math.round(viewport.scrollLeft/w));
      });
    },{passive:true});
    thumbBtns.forEach(function(b,i){
      b.addEventListener("click",function(){markActive(i);goTo(i)});
    });
    viewport.addEventListener("keydown",function(e){
      if(e.key==="ArrowRight"){e.preventDefault();goTo(Math.min(active+1,slides.length-1))}
      else if(e.key==="ArrowLeft"){e.preventDefault();goTo(Math.max(active-1,0))}
    });
  }

  function money(c){var n=c/100;return "$"+(n%1?n.toFixed(2):n)}

  /* size selection state */
  var chosenSize=null;
  var mainAtc=$("#mainAtc"),variantInput=$("[data-crk-variant-id]");
  function setSize(sz){
    chosenSize=sz;
    var v=PRODUCT.variants[sz];
    if(v&&variantInput)variantInput.value=v.id;
    if(mainAtc)mainAtc.classList.remove("muted");
    var n=$("#sizeNudge");if(n)n.classList.remove("on");
    var radio=document.getElementById("sz"+sz);if(radio)radio.checked=true;
    var ss=$("#stickySize");if(ss)ss.textContent=money(PRODUCT.price)+" · size "+sz;
  }
  window.CRKPDP={setSize:setSize};
  document.querySelectorAll('#sizeBlock input[name="options[Size]"]').forEach(function(r){
    r.addEventListener("change",function(){setSize(r.value)});
  });

  /* Drawer guards. The gallery no longer gates on CRKDrawer, so every buy-path
     call must check at its own use site. When the drawer is genuinely absent the
     right move is NOT to swallow the click — it is to let the real Shopify
     <form action="/cart/add"> submit, which is why the markup keeps real form
     semantics in the first place. */
  function addToCart(size){
    var v=PRODUCT.variants[size];
    if(!v)return false;
    if(!window.CRKDrawer)return false;              // caller falls back to native submit
    window.CRKDrawer.addLine({variant_id:v.id,handle:PRODUCT.handle,title:PRODUCT.title,
      price:PRODUCT.price,img:PRODUCT.img,size:size});
    return true;
  }

  /* main ATC — NEAR sad path: muted-clickable; no size → scroll + nudge, never dead */
  var form=$("[data-crk-atc-form]");
  if(form)form.addEventListener("submit",function(e){
    if(!chosenSize){
      e.preventDefault();
      $("#sizeBlock").scrollIntoView({behavior:"smooth",block:"center"});
      $("#sizeNudge").classList.add("on");
      return;
    }
    if(addToCart(chosenSize))e.preventDefault();     // otherwise: native POST /cart/add
  });

  /* sticky bar — FAR sad path: full-color CTA + self-contained sheet */
  var gal=document.querySelector(".crk-gal"),sticky=$("#stickyBar");
  if(gal&&sticky){
    window.addEventListener("scroll",function(){
      sticky.classList.toggle("on",gal.getBoundingClientRect().bottom<0);
    },{passive:true});
    $("#stickyAtc").addEventListener("click",function(){
      if(chosenSize){
        if(!addToCart(chosenSize)&&form)form.submit();   // native fallback
        return;
      }
      if(window.CRKDrawer)window.CRKDrawer.openSheet(PRODUCT,"primary");
      else $("#sizeBlock").scrollIntoView({behavior:"smooth",block:"center"});
    });
  }

  /* complete-the-fit rail — server-rendered cards; adds open the shared "ctf" sheet */
  document.querySelectorAll("[data-crk-rail-item]").forEach(function(b){
    b.addEventListener("click",function(){
      if(window.CRKDrawer)window.CRKDrawer.openSheet(JSON.parse(b.dataset.crkRailItem),"ctf");
    });
  });

  /* size-chart lightbox (chart lives here, not in the swipe gallery) */
  var chartOpen=$("#sizeChartOpen"),chartBox=$("#chartBox"),chartVeil=$("#chartVeil");
  if(chartOpen&&chartBox){
    var openChart=function(){
      var img=chartBox.querySelector("img[data-chart-src]");
      if(img&&!img.src){img.src=img.dataset.chartSrc}
      chartBox.classList.add("on");chartVeil.classList.add("on");
    };
    var closeChart=function(){chartBox.classList.remove("on");chartVeil.classList.remove("on")};
    chartOpen.addEventListener("click",openChart);
    $("#chartClose").addEventListener("click",closeChart);
    chartVeil.addEventListener("click",closeChart);
    chartBox.addEventListener("click",function(e){if(e.target===chartBox)closeChart()});
    document.addEventListener("keydown",function(e){if(e.key==="Escape")closeChart()});
  }
})();
